import { render, staticRenderFns } from "./addTypeItem.vue?vue&type=template&id=c9b40032&scoped=true&"
import script from "./addTypeItem.vue?vue&type=script&lang=js&"
export * from "./addTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./addTypeItem.vue?vue&type=style&index=0&id=c9b40032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b40032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b40032')) {
      api.createRecord('c9b40032', component.options)
    } else {
      api.reload('c9b40032', component.options)
    }
    module.hot.accept("./addTypeItem.vue?vue&type=template&id=c9b40032&scoped=true&", function () {
      api.rerender('c9b40032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/addTypeItem.vue"
export default component.exports